import { gql } from '@apollo/client';

export const CREATE_DOCUMENT_TYPE = gql`
  mutation CreateChatbotDocumentType($params: CreateDocumentTypeInput!) {
    createChatbotDocumentType(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        chunkSize
        chunkOverlap
        createdAt
        createdBy
      }
    }
  }
`;

export const UPDATE_DOCUMENT_TYPE = gql`
  mutation UpdateChatbotDocumentType($params: UpdateDocumentType!) {
    updateChatbotDocumentType(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        chunkSize
        chunkOverlap
        createdAt
        createdBy
      }
    }
  }
`;

export const DELETE_DOCUMENT_TYPE = gql`
  mutation DeleteChatbotDocumentType($params: DeleteDocumentType!) {
    deleteChatbotDocumentType(params: $params) {
      success
      message
      errors
    }
  }
`;
